import { render } from "./topToolbar.vue?vue&type=template&id=f6b46422&scoped=true&ts=true"
import script from "./topToolbar.vue?vue&type=script&lang=ts"
export * from "./topToolbar.vue?vue&type=script&lang=ts"

import "./topToolbar.vue?vue&type=style&index=0&id=f6b46422&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6b46422"]])

export default __exports__